import { Stack } from '@fluentui/react';
import React, { RefObject } from 'react';
import { injectIntlAndObserver, IRouterWithIntl } from '../../../../utils';
import { TythonColumnsEnum } from '../../@data/store/schema/ColumnsEnum';
import { IReportsMetadata, PubCenterReportingDataRow } from '../../DashboardCards/@data/store/schema';
import { ReportCard } from '../../DashboardCards/ReportCard/ReportCard';
import { ChartGrain, ChartTypes, IChartButton, ReportCardType } from '../../DashboardCards/ReportCard/ReportCard.types';
import { ICustomCalenderDateRange } from '../../components/CustomCalender/CustomCalender.types';
import { getDefaultMetrics } from '../utils/utils';

interface IPerformanceProps extends IRouterWithIntl {
  hideChart?: boolean;
  searchQuery?: string;
  reportMetadata?: IReportsMetadata;
  reportData?: PubCenterReportingDataRow[];
  reportDataDate?: PubCenterReportingDataRow[];
  reportDataSummary?: PubCenterReportingDataRow[];
  dateRange: ICustomCalenderDateRange;
  reportType: string;
  defaultSelectedColumns: TythonColumnsEnum[];
  cardRef: RefObject<HTMLDivElement>;
  chartGrain?: ChartGrain;
  setDefaultSelectedColumns: React.Dispatch<React.SetStateAction<string[]>>;
}

export const PERFORMANCE_ALLOWED_CHARTS: IChartButton[] = [
  { chartType: ChartTypes.LINE, disabled: false, iconName: '', dataTestId: 'PERFORMANCE_CHART_TYPE_LINE_BUTTON' },
];

export const PerformanceChartComponent = injectIntlAndObserver((props: IPerformanceProps) => {
  return (
    <Stack>
      <Stack.Item grow basis={'100%'} style={{ width: '100%' }}>
        <ReportCard
          legend={false}
          match={props.match}
          title={''}
          dateRange={props.dateRange}
          history={props.history}
          location={props.location}
          reportMetadata={props.reportMetadata}
          type={ReportCardType.PERFORMANCE}
          allowedChartTypes={PERFORMANCE_ALLOWED_CHARTS}
          allowedChartGrains={[]}
          showDetailsReportLink={false}
          isDetailedView={true}
          filters={[]}
          reportCardRef={props.cardRef}
          dateDimension={TythonColumnsEnum.Date}
          dataMetrics={{ chartDataMetrics: 'Performance Card ID' }}
          summaryData={props.reportDataSummary}
          reportData={props.reportDataDate}
          reportDetailedData={props.reportData}
          isSummaryDataLoaded={true}
          defaultColumns={props.defaultSelectedColumns}
          defaultMetrics={getDefaultMetrics(props.reportType)}
          showMetricsMarkers={true}
          hideCommandBar={true}
          hideChart={props.hideChart}
          searchQuery={props.searchQuery}
          reportType={props.reportType}
          setDefaultSelectedColumns={props.setDefaultSelectedColumns}
          defaultChartGrain={props.chartGrain}
          isPubCenterChart
        />
      </Stack.Item>
    </Stack>
  );
});
